// SPDX-FileCopyrightText: 2023 Félix Robles <felix@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { createSlice } from "@reduxjs/toolkit";
var initialState = {};
export var ballotStylesSlice = createSlice({
    name: "ballotStyles",
    initialState: initialState,
    reducers: {
        setBallotStyle: function (state, action) {
            state[action.payload.election_id] = action.payload;
            return state;
        },
    },
});
export var setBallotStyle = ballotStylesSlice.actions.setBallotStyle;
export var selectBallotStyleByElectionId = function (electionId) { return function (state) {
    return state.ballotStyles[electionId];
}; };
export var selectBallotStyleElectionIds = function (state) { return Object.keys(state.ballotStyles); };
export var selectFirstBallotStyle = function (state) { var _a; return (_a = Object.values(state.ballotStyles)) === null || _a === void 0 ? void 0 : _a[0]; };
export default ballotStylesSlice.reducer;
